import React from "react";
import LandingPage from "../function-components/LandingPage";

function Home() {
  return (
    <>
      <LandingPage />
    </>
  );
}

export default Home;
